/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const fuelType = async (): Promise<any> => {
  const fuelType = useJSONStore.getState().fuelType;
  const token = useUserStore.getState().userToken;
  const setFuelType = useJSONStore.getState().setFuelType;

  if (fuelType.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.fuelType}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setFuelType(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default fuelType;
